// Paidads.js
import React, { useState } from 'react';
import { GeneralBox } from '../../Shared/GeneralBox';
import ParticlesBG from "../../Shared/ParticlesBG";

// Assets
import aiImage from '../../Assets/Images/AI.png';
import customImage from '../../Assets/Images/Custom.png';
import prebuiltImage from '../../Assets/Images/Prebuilt.png';

// Import the components with their correct file names
import OptionAIPaid from './Paidads/OptionAIPaid';
import OptionPrebuiltPaid from './Paidads/OptionPrebuiltPaid';
import OptionCustomPaid from './Paidads/OptionCustomPaid';

export default function Paidads() {
  const [selectedOption, setSelectedOption] = useState('');
  const [isCollapsed, setIsCollapsed] = useState(false);

  // Handle option selection
  const handleOptionSelect = (option) => {
    setSelectedOption(option);
    setIsCollapsed(true); // Collapse the section when an option is selected
  };

  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };

  // Helper function to render the correct option component based on selection
  function renderOptionComponent() {
    switch (selectedOption) {
      case 'ARTIFICIAL INTELLIGENCE': return <OptionAIPaid />;
      case 'PREBUILT': return <OptionPrebuiltPaid />;
      case 'CUSTOM': return <OptionCustomPaid />;
      default: return null;
    }
  }

  return (
    <div id="paidads-page">
      <section className="paidads-header">
        <div className="particles circle-bg">
          <div className="container">
            <div className="title-box">
              <h1>
                <span className="color-font">PAID ADVERTISEMENT</span>
              </h1>
            </div>
          </div>

          <ParticlesBG />
          
          <div className="gradient-circle"></div>
          <div className="gradient-circle two"></div>
        </div>
      </section>
      
      <section className="services">
        <div className="container">
          <div className="paidads-intro">
            <p>
              Strategic paid advertising amplifies your brand's reach and drives conversions.
              <span className="highlight"> Businesses using targeted paid campaigns see an average ROI of 200%</span>,
              delivering measurable results across multiple platforms.
            </p>
          </div>
          <h2><span className="color-font">Campaign Building Options</span></h2>
          <p className="options-subtitle">Select the approach that best suits your advertising needs</p>
          
          <div className="collapse-section">
            <button onClick={toggleCollapse} className="collapse-toggle">
              {isCollapsed && selectedOption ? 'Change Selection' : isCollapsed ? 'Show Options' : 'Hide Options'}
            </button>
          </div>
          
          {/* Options display using GeneralBox */}
          {!isCollapsed && (
            <div className="box-column-container">
              <div className="box-column" onClick={() => handleOptionSelect('ARTIFICIAL INTELLIGENCE')}>
                <GeneralBox
                  title="ARTIFICIAL INTELLIGENCE"
                  link="#"
                  imageSrc={aiImage}
                  description="AI-powered campaign optimization for maximum results"
                  className={`homepage-box ${selectedOption === 'ARTIFICIAL INTELLIGENCE' ? 'selected-box' : ''}`}
                  useGlow={true}
                />
              </div>
              <div className="box-column" onClick={() => handleOptionSelect('PREBUILT')}>
                <GeneralBox
                  title="PREBUILT"
                  link="#"
                  imageSrc={prebuiltImage}
                  description="Pre-configured campaign templates for quick deployment"
                  className={`homepage-box ${selectedOption === 'PREBUILT' ? 'selected-box' : ''}`}
                  useGlow={true}
                />
              </div>
              <div className="box-column" onClick={() => handleOptionSelect('CUSTOM')}>
                <GeneralBox
                  title="CUSTOM"
                  link="#"
                  imageSrc={customImage}
                  description="Fully customized campaigns tailored to your specific objectives"
                  className={`homepage-box ${selectedOption === 'CUSTOM' ? 'selected-box' : ''}`}
                  useGlow={true}
                />
              </div>
            </div>
          )}
          
          {/* Render the selected option component */}
          {selectedOption && (
            <div className="selected-option-container">
              {selectedOption === 'ARTIFICIAL INTELLIGENCE' && (
                <h2 className="selection-title">AI-Powered Campaign Builder</h2>
              )}
              {selectedOption === 'CUSTOM' && (
                <>
                  <h2 className="selection-title">Platform Selection</h2>
                  {/* Platform options will go here */}
                </>
              )}
              {selectedOption === 'PREBUILT' && (
                <>
                  <h2 className="selection-title">Platform Selection</h2>
                  <p className="selection-subtitle">
                    If you want to build a campaign on more than 1 platform, please select the Custom Builder or AI Builder
                  </p>
                  {/* Platform options will go here */}
                </>
              )}
              {renderOptionComponent()}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
